/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const t=t=>"field"===t.type,e=t=>"group"===t.type,p=t=>"text"===t.type,o=t=>"relationship"===t.type;export{t as isFieldElement,e as isGroupElement,o as isRelationshipElement,p as isTextElement};
